var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings-page" },
    [
      _c(
        "pui-tabs",
        {
          staticClass: "settings-page__tabs",
          attrs: { selected: _vm.selectedTabIndex },
          on: { changed: _vm.onTabChanged },
        },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "pui-tab",
            {
              key: tab,
              staticClass: "settings-page__tab",
              attrs: { title: tab },
            },
            [
              _vm.selectedTabIndex === 0
                ? _c("thresholds-tab")
                : _vm.selectedTabIndex === 1
                ? _c("email-settings-tab")
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }